import styles from './programme-workout-screen.module.scss'
import React from 'react'
import { useParams } from 'react-router-dom'
import { PageContainer } from 'src/component/page-container/page-container'
import { ProgrammeWorkoutHeader } from 'src/component/workout/programme-workout-header'
import { WorkoutDisplay } from 'src/component/workout/workout-display'
import { useProgrammeWorkouts } from 'src/hook/use-programme-workouts'
import { useWorkout } from 'src/hook/use-workouts'

export const ProgrammeWorkoutScreen = (): React.ReactElement => {
  const { programmeId, programmeWorkoutId, workoutId } = useParams<{
    programmeId: string
    programmeWorkoutId: string
    workoutId: string
  }>()

  const { data: workout, isLoading: isLoadingWorkout } = useWorkout(workoutId || '')
  const { data: programmeWorkouts = [], isLoading: isLoadingProgrammeWorkouts } = useProgrammeWorkouts(programmeId || '')

  if (!programmeId || !programmeWorkoutId || !workoutId) {
    return <div>Programme workout not found</div>
  }

  if (isLoadingWorkout || isLoadingProgrammeWorkouts || !workout) {
    return <div>Loading...</div>
  }

  return (
    <PageContainer>
      <div className={styles.container}>
        <ProgrammeWorkoutHeader
          programmeId={programmeId}
          currentProgrammeWorkoutId={programmeWorkoutId}
          allProgrammeWorkouts={programmeWorkouts}
        />
        <WorkoutDisplay workout={workout} programmeId={programmeId} programmeWorkoutId={programmeWorkoutId} />
      </div>
    </PageContainer>
  )
}
